<template>
  <div class="my-register-page mb-5 pr-page">
    <div class="my-container">
      <b-row class="mb-2 mt-3 pt-3 align-items-center">
        <b-col>
          <h1 class="m-0">{{ $t("PublicReception") }}</h1>
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col sm="12" md="9">
          <div class="pr-search">
            <b-icon icon="search" class="pr-search-icon"></b-icon>
            <b-form-input
              v-model="filter.search"
              :placeholder="$t('PublicReceptionSearch')"
              @keyup.enter="Refresh"
              class="pr-search-input"
            ></b-form-input>
          </div>
        </b-col>
      </b-row>

      <div class="pr-tabs mb-4">
        <button
          v-for="tab in StatusTabs"
          :key="tab.value"
          type="button"
          class="pr-tab"
          :class="{ active: filter.statusId === tab.value }"
          @click="SetStatus(tab.value)"
        >
          {{ tab.label }}
          <span
            v-if="tab.value === filter.statusId || tab.value === 0"
            class="pr-tab-count"
          >
            {{ tab.value === filter.statusId ? filter.totalRows : (Counts[tab.countKey] || 0) }}
          </span>
        </button>
      </div>

      <div v-if="Items.length === 0" class="pr-empty text-center py-5">
        {{ $t("NoItems") }}
      </div>

      <div
        v-for="(item, index) in Items"
        :key="index"
        class="pr-card mb-3"
      >
        <div class="pr-card-body">
          <div class="pr-card-header d-flex flex-wrap align-items-center">
            <h4 class="pr-card-title m-0">{{ item.name }}</h4>
            <!-- <span v-if="item.docNumber" class="pr-doc-number ml-2">
              {{ item.docNumber }}
            </span> -->
          </div>

          <div class="pr-card-meta d-flex flex-wrap mt-2">
            <span class="pr-meta-item" v-if="item.receptionDate">
              <b-icon icon="calendar2-event"></b-icon>
              {{ item.receptionDate }}
            </span>
            <span class="pr-meta-item" v-if="item.region">
              <b-icon icon="geo-alt"></b-icon>
              {{ item.region }}<span v-if="item.district">, {{ item.district }}</span>
            </span>
          </div>

          <!-- <div class="pr-card-badges mt-2">
            <span v-if="item.status" class="pr-badge pr-badge-status">{{ item.status }}</span>
            <span v-if="isValidType(item.receptionType)" class="pr-badge pr-badge-type">
              {{ item.receptionType }}
            </span>
          </div> -->
        </div>

        <div class="pr-card-actions">
          <b-button
            variant="primary"
            size="sm"
            class="pr-detail-btn"
            @click="GoToView(item)"
          >
            {{ $t("Batafsil") }}
            <b-icon icon="box-arrow-up-right"></b-icon>
          </b-button>
        </div>
      </div>

      <b-pagination
        v-if="filter.totalRows > filter.pageSize"
        v-model="filter.page"
        :total-rows="filter.totalRows"
        :per-page="filter.pageSize"
        first-number
        last-number
        @input="Refresh"
        class="mb-0 mt-3"
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <b-icon icon="chevron-double-left" size="18" />
        </template>
        <template #next-text>
          <b-icon icon="chevron-double-right" size="18" />
        </template>
      </b-pagination>
    </div>
  </div>
</template>

<script>
import PublicReceptionService from "@/services/publicreception.service";
import {
  BRow,
  BCol,
  BButton,
  BFormInput,
  BPagination,
  BIcon,
} from "bootstrap-vue";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BFormInput,
    BPagination,
    BIcon,
  },
  data() {
    return {
      Items: [],
      Counts: {
        all: 0,
        upcoming: 0,
        planned: 0,
        ongoing: 0,
        held: 0,
      },
      filter: {
        search: "",
        statusId: 0,
        page: 1,
        pageSize: 10,
        totalRows: 0,
      },
    };
  },
  computed: {
    StatusTabs() {
      return [
        { value: 0, label: this.$t("PRTabAll"), countKey: "all" },
        { value: 1, label: this.$t("PRTabUpcoming"), countKey: "upcoming" },
        { value: 2, label: this.$t("PRTabPlanned"), countKey: "planned" },
        { value: 3, label: this.$t("PRTabOngoing"), countKey: "ongoing" },
        { value: 4, label: this.$t("PRTabHeld"), countKey: "held" },
      ];
    },
  },
  created() {
    this.Refresh();
  },
  methods: {
    Refresh() {
      PublicReceptionService.GetList(this.filter)
        .then((res) => {
          this.Items = res.data.rows || res.data.items || [];
          this.filter.totalRows = res.data.total || res.data.totalRows || 0;
          if (res.data.counts) {
            this.Counts = { ...this.Counts, ...res.data.counts };
          }
        })
        .catch((error) => {
          this.makeToast(
            error.response ? error.response.data : error.message,
            "error"
          );
        });
    },
    SetStatus(value) {
      this.filter.statusId = value;
      this.filter.page = 1;
      this.Refresh();
    },
    GoToView(item) {
      this.$router.push({
        name: "PublicReceptionView",
        params: { id: item.id },
      });
    },
    isValidType(value) {
      if (!value) return false;
      return !/^[A-Z][A-Za-z0-9]*(\.[A-Z][A-Za-z0-9]+){2,}/.test(value);
    },
    makeToast(message, type) {
      var a = "";
      if (message && message.status == 500) {
        a = message.title;
      } else if (message && message.status == 400) {
        var errors = Object.values(message.errors);
        a = errors.map((el, i) => i + 1 + "." + el).join("\n");
      } else {
        a = message;
      }
      this.$toast.open({
        message: a,
        type: type,
        duration: 5000,
        dismissible: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.pr-page h1 {
  color: $primary-dark;
  font-weight: 700;
}

.pr-search {
  position: relative;
}

.pr-search-icon {
  position: absolute;
  top: 50%;
  left: 16px;
  transform: translateY(-50%);
  color: #6c757d;
  font-size: 16px;
  pointer-events: none;
  z-index: 2;
}

.pr-search-input {
  width: 100%;
  height: 44px;
  padding-left: 44px;
  padding-right: 16px;
  border: 1px solid #e2e6ee;
  border-radius: 12px !important;
  background-color: #fff;
  box-shadow: none !important;

  &:focus {
    border-color: $primary;
    background-color: #fff;
  }
}

.pr-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.pr-tab {
  border: 1px solid #e2e6ee;
  background: #fff;
  border-radius: 999px;
  padding: 8px 16px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: $primary-dark;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    border-color: $primary;
  }

  &.active {
    background: $primary-dark;
    border-color: $primary-dark;
    color: #fff;

    .pr-tab-count {
      background: rgba(255, 255, 255, 0.2);
      color: #fff;
    }
  }
}

.pr-tab-count {
  background: #eef2f8;
  color: $primary-dark;
  border-radius: 999px;
  font-size: 12px;
  padding: 2px 8px;
  min-width: 24px;
  text-align: center;
}

.pr-card {
  background: #fff;
  border: 1px solid #e2e6ee;
  border-radius: 12px;
  padding: 18px 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  @media (max-width: 575px) {
    flex-wrap: wrap;
  }
}

.pr-card-body {
  flex: 1 1 auto;
  min-width: 0;
}

.pr-card-title {
  font-size: 18px;
  font-weight: 600;
  color: $primary-dark;
  margin-bottom: 8px;
}

.pr-doc-number {
  background: #f1f3f5;
  color: #495057;
  border-radius: 6px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 500;
}

.pr-card-stats {
  gap: 18px;
  color: #5f6b7a;
  font-size: 13px;
}
.pr-stat-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  b {
    color: $primary-dark;
  }
}

.pr-card-meta {
  gap: 18px;
  color: #5f6b7a;
  font-size: 14px;
}

.pr-meta-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.pr-card-badges {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.pr-badge {
  background: #eef4ff;
  color: $primary-dark;
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 500;
}

.pr-card-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-shrink: 0;
}

.pr-map-btn {
  border-radius: 8px;
}

.pr-detail-btn {
  background: $primary-dark !important;
  border-color: $primary-dark !important;
  border-radius: 8px;
  color: #fff;
}

.pr-empty {
  color: #6c757d;
}
</style>
